import { render } from "./bayadTransactionList.vue?vue&type=template&id=fde4add6"
import script from "./bayadTransactionList.vue?vue&type=script&lang=js"
export * from "./bayadTransactionList.vue?vue&type=script&lang=js"

import "./bayadTransactionList.vue?vue&type=style&index=0&id=fde4add6&lang=css"

import exportComponent from "C:\\WSS-BuildAgent\\_work\\5\\s\\Sureload Admin\\sureload-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__